import { Routes } from '@angular/router';

import { BrowseComponent } from './pages/browse/browse.component';
import { CatalogComponent } from './pages/catalog/catalog.component';
import { CoachingComponent } from './pages/coaching/coaching.component';
import { SearchComponent } from './pages/search/search.component';
import { TrainingLogPageComponent } from './pages/training-log/training-log.component';
import { UploadPageComponent } from './pages/upload/upload.page.component';
import { WatchComponent } from './pages/watch/watch.component';
import { PlaylistDetailComponent } from './pages/playlist-detail/playlist-detail.component';
import { GpsOnlyPageComponent } from './pages/gps-only/gps-only.component';
import { WorkoutComponent } from './pages/workout/workout.component';

export const browsesRoutes: Routes = [
  {
    children: [
      {
        component: CatalogComponent,
        data: {
          banner: true,
          permanentBanner: true,
        },
        path: '',
      },
      {
        component: UploadPageComponent,
        path: 'upload',
      },
      {
        component: WatchComponent,
        path: 'watch/:videoId',
      },
      {
        component: CoachingComponent,
        path: 'coaching/:coachingId',
      },
      {
        component: GpsOnlyPageComponent,
        path: 'gps-only/:gpsOnlyId',
      },
      {
        component: WorkoutComponent,
        path: 'workout/:workoutId',
      },
      {
        component: TrainingLogPageComponent,
        path: 'training-log/:activityId',
      },
      {
        component: SearchComponent,
        path: 'search',
      },
      {
        component: SearchComponent,
        data: {
          permanentBanner: true,
        },
        path: 'search/:term',
      },
      {
        component: PlaylistDetailComponent,
        path: 'playlists/:playlistId',
      },
      { path: '**', redirectTo: '' },
    ],
    component: BrowseComponent,
    path: '',
  },
];
